module.exports = __webpack_public_path__ + "static/media/md-cube.9e89bea7.svg";